module.exports = __webpack_public_path__ + "static/media/futurama-bold.3d20efac.ttf";